import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { EnvconfigService } from '../envconfig.service';
 

@Injectable({
    providedIn: 'root'
})
export class EncryptDecryptService {
    private key ;
    private iv:any;
    constructor(   private environment: EnvconfigService) {

        this.key =  CryptoJS.enc.Utf8.parse(this.environment.get("EncryptKey"));
        this.iv = CryptoJS.enc.Utf8.parse(this.environment.get("EncryptIV"));
 
    }
    encryptUsingAES256(text:any): any {
        let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(text), this.key, {
            keySize: 128 / 8,
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    }
    decryptUsingAES256(decString:any) {

        try {
            let ciphertextBytes = CryptoJS.enc.Hex.parse(decString);
            let ciphertextInBase64 = CryptoJS.enc.Base64.stringify(ciphertextBytes);

            let decrypted = CryptoJS.AES.decrypt(ciphertextInBase64, this.key, {
            keySize: 128 / 8,
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
 
        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        // Manejar el error aquí. Podrías, por ejemplo, registrar el error o devolver un mensaje de error específico.
        console.error(error);
        return null; // Devuelve null o maneja el error de forma que mejor se ajuste a tu aplicación
    }
    }


    decryptTokenUsingAES256(decString:any) {
        try {
            let decrypted = CryptoJS.AES.decrypt(decString, this.key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        // Manejar el error aquí. Podrías, por ejemplo, registrar el error o devolver un mensaje de error específico.
        console.error(error);
        return null; // Devuelve null o maneja el error de forma que mejor se ajuste a tu aplicación
    }
    }
}